document.addEventListener("DOMContentLoaded", () => {

    const radios = document.querySelectorAll('input[name="hedge-mode"]');
    const area = document.getElementById("hedge-length-area");
    const input = document.getElementById("hedge-length");
    const result = document.getElementById("hedge-result");

    const variantData = JSON.parse(
        document.getElementById("hedge-variant-data").textContent
    );

    /*
     * ==========================================
     * MENGENRABATT
     * ==========================================
     */

    const discountTiers = [
        {
            min: 1,
            max: 20,
            discount: 0
        },
        {
            min: 21,
            max: 50,
            discount: 10
        },
        {
            min: 51,
            max: 100,
            discount: 15
        },
        {
            min: 101,
            max: Infinity,
            discount: 20
        }
    ];


    /*
     * ==========================================
     * AKTUELLE VARIANTE
     * ==========================================
     */

    function getCurrentVariantId() {

        const variantInput =
            document.querySelector('input[name="id"]');

        if (!variantInput) return null;

        return Number(variantInput.value);

    }


    function getCurrentVariant() {

        const variant =
            variantData.find(
                v => v.id === getCurrentVariantId()
            );

        console.log("Aktuelle Variante:", variant);

        return variant;

    }


    function getPlantsPerMeter() {

        const currentVariant =
            getCurrentVariant();

        if (!currentVariant) return 0;

        return Number(
            currentVariant.plants_per_meter
        );

    }


    /*
     * ==========================================
     * AKTUELLE MENGE
     * ==========================================
     */

    function getCurrentQuantity() {

        const quantitySelector =
            document.querySelector(
                "quantity-selector-component"
            );

        if (
            !quantitySelector ||
            !quantitySelector.getValue
        ) {
            return 1;
        }

        return Number(
            quantitySelector.getValue()
        ) || 1;

    }


    /*
     * ==========================================
     * STARTZUSTAND
     * ==========================================
     */

    function setInitialState() {

        /*
         * Stückzahl auswählen
         */

        const piecesRadio =
            document.querySelector(
                'input[name="hedge-mode"][value="pieces"]'
            );

        const lengthRadio =
            document.querySelector(
                'input[name="hedge-mode"][value="length"]'
            );

        if (piecesRadio) {
            piecesRadio.checked = true;
        }

        if (lengthRadio) {
            lengthRadio.checked = false;
        }

        /*
         * Heckenlängen-Bereich verstecken
         */

        if (area) {
            area.style.display = "none";
        }

        /*
         * Startmenge auf 21 setzen
         */

        const quantitySelector =
            document.querySelector(
                "quantity-selector-component"
            );

        if (
            quantitySelector &&
            quantitySelector.setValue
        ) {

            quantitySelector.setValue("21");

        } else {

            const quantityInput =
                document.querySelector(
                    'input[name="quantity"]'
                );

            if (quantityInput) {

                quantityInput.value = "21";

                quantityInput.dispatchEvent(
                    new Event("input", {
                        bubbles: true
                    })
                );

                quantityInput.dispatchEvent(
                    new Event("change", {
                        bubbles: true
                    })
                );

            }

        }

    }


    /*
     * ==========================================
     * RABATTSTUFE
     * ==========================================
     */

    function getDiscountForQuantity(quantity) {

        let currentTier =
            discountTiers[0];

        for (const tier of discountTiers) {

            if (quantity >= tier.min) {
                currentTier = tier;
            }

        }

        return currentTier;

    }


    function getNextDiscountTier(quantity) {

        return discountTiers.find(
            tier => tier.min > quantity
        );

    }


    /*
     * ==========================================
     * RABATTBOX AUFBAUEN
     * ==========================================
     */

    function buildDiscountBox() {

        const tiersContainer =
            document.getElementById(
                "hedge-discount-tiers"
            );

        if (!tiersContainer) return;

        tiersContainer.innerHTML = "";

        const variant =
            getCurrentVariant();

        if (!variant) return;

        const basePrice =
            Number(variant.price) / 100;

        discountTiers.forEach(tier => {

            /*
             * Genau wie Shopify:
             * erst Stückpreis auf Cent runden
             */

            const discountedPrice =
                Math.round(
                    basePrice *
                    (1 - tier.discount / 100) *
                    100
                ) / 100;

            let quantityText;

            if (tier.max === Infinity) {

                quantityText =
                    `${tier.min}+`;

            } else {

                quantityText =
                    `${tier.min}–${tier.max}`;

            }

            const row =
                document.createElement("div");

            row.className =
                "hedge-discount-tier";

            row.dataset.min =
                tier.min;

            row.dataset.max =
                tier.max;

            row.innerHTML = `
                <span class="hedge-discount-quantity">
                    ${quantityText} Pflanzen
                </span>

                <span class="hedge-discount-percent">
                    ${
                        tier.discount > 0
                            ? tier.discount + "% sparen"
                            : "Normalpreis"
                    }
                </span>

                <span class="hedge-discount-price">
                    ${discountedPrice.toLocaleString("de-DE", {
                        style: "currency",
                        currency: "EUR"
                    })} / Stück
                </span>
            `;

            tiersContainer.appendChild(row);

        });

    }


    /*
     * ==========================================
     * RABATTANZEIGE AKTUALISIEREN
     * ==========================================
     */

    function updateDiscountDisplay() {

        const quantity =
            getCurrentQuantity();

        const currentTier =
            getDiscountForQuantity(quantity);

        const rows =
            document.querySelectorAll(
                ".hedge-discount-tier"
            );

        rows.forEach(row => {

            const min =
                Number(row.dataset.min);

            const max =
                Number(row.dataset.max);

            if (
                quantity >= min &&
                quantity <= max
            ) {

                row.classList.add("active");

            } else {

                row.classList.remove("active");

            }

        });


        /*
         * Nächste Rabattstufe
         */

        const nextElement =
            document.getElementById(
                "hedge-discount-next"
            );

        if (!nextElement) return;

        const nextTier =
            getNextDiscountTier(quantity);

        if (nextTier) {

            const difference =
                nextTier.min - quantity;

            const variant =
                getCurrentVariant();

            if (!variant) return;

            const basePrice =
                Number(variant.price) / 100;

            const currentPrice =
                Math.round(
                    basePrice *
                    (1 - currentTier.discount / 100) *
                    100
                ) / 100;

            const nextPrice =
                Math.round(
                    basePrice *
                    (1 - nextTier.discount / 100) *
                    100
                ) / 100;

            const savingPerPlant =
                currentPrice - nextPrice;

            const possibleSaving =
                difference * savingPerPlant;

            nextElement.innerHTML = `
                Noch <strong>${difference}</strong>
                Pflanzen bis zu
                <strong>${nextTier.discount}% Rabatt</strong>.
                <br>
                <span>
                    Damit sparst du zusätzlich
                    <strong>
                        ${possibleSaving.toLocaleString("de-DE", {
                            style: "currency",
                            currency: "EUR"
                        })}
                    </strong>.
                </span>
            `;

        } else {

            nextElement.innerHTML = `
                🎉 <strong>
                    Du hast bereits unseren höchsten Mengenrabatt!
                </strong>
            `;

        }

    }


    /*
     * ==========================================
     * PREISE AKTUALISIEREN
     * ==========================================
     */

    function updatePriceFromQuantity() {

        const variant =
            getCurrentVariant();

        if (!variant) return;

        const quantity =
            getCurrentQuantity();

        const currentTier =
            getDiscountForQuantity(quantity);

        const basePrice =
            Number(variant.price) / 100;

        /*
         * Rabattpreis auf Cent runden,
         * damit er exakt zum Warenkorb passt.
         */

        const discountedPrice =
            Math.round(
                basePrice *
                (1 - currentTier.discount / 100) *
                100
            ) / 100;


        /*
         * Stückpreis oben auf der Produktseite
         */

        const formattedUnitPrice =
            discountedPrice.toLocaleString(
                "de-DE",
                {
                    style: "currency",
                    currency: "EUR"
                }
            );

        const productPrice =
            document.querySelector(
                "product-price .price"
            );

        if (productPrice) {

            productPrice.textContent =
                formattedUnitPrice;

        }


        /*
         * Gesamtpreis
         */

        const totalPrice =
            quantity * discountedPrice;

        const priceElement =
            document.getElementById(
                "hedge-total-price"
            );

        if (priceElement) {

            priceElement.innerText =
                totalPrice.toLocaleString(
                    "de-DE",
                    {
                        style: "currency",
                        currency: "EUR"
                    }
                );

        }

        updateDiscountDisplay();

    }


    /*
     * ==========================================
     * HECKENLÄNGE BERECHNEN
     * ==========================================
     */

    function calculate() {

        const meters =
            parseFloat(input.value);

        if (
            isNaN(meters) ||
            meters <= 0
        ) {

            result.innerText = "-";

            return;

        }

        const plantsPerMeter =
            getPlantsPerMeter();

        const plants =
            Math.ceil(
                meters * plantsPerMeter
            );

        result.innerText =
            plants + " Pflanzen";


        /*
         * Menge automatisch setzen
         */

        const quantitySelector =
            document.querySelector(
                "quantity-selector-component"
            );

        if (
            quantitySelector &&
            quantitySelector.setValue
        ) {

            quantitySelector.setValue(
                plants.toString()
            );

        }

        updatePriceFromQuantity();

    }


    /*
     * ==========================================
     * STÜCKZAHL / HECKENLÄNGE
     * ==========================================
     */

    radios.forEach(radio => {

        radio.addEventListener(
            "change",
            () => {

                /*
                 * HECKENLÄNGE
                 */

                if (
                    radio.value === "length" &&
                    radio.checked
                ) {

                    area.style.display =
                        "block";

                    calculate();

                }


                /*
                 * STÜCKZAHL
                 */

                if (
                    radio.value === "pieces" &&
                    radio.checked
                ) {

                    area.style.display =
                        "none";

                    updatePriceFromQuantity();

                }

            }
        );

    });


    /*
     * ==========================================
     * HECKENLÄNGE GEÄNDERT
     * ==========================================
     */

    input.addEventListener(
        "input",
        () => {

            calculate();

        }
    );


    /*
     * ==========================================
     * VARIANTE GEÄNDERT
     * ==========================================
     */

    const variantInput =
        document.querySelector(
            'input[name="id"]'
        );

    if (variantInput) {

        const observer =
            new MutationObserver(() => {

                buildDiscountBox();

                updatePriceFromQuantity();

                /*
                 * Nur im Heckenlängen-Modus
                 * neu berechnen
                 */

                const lengthRadio =
                    document.querySelector(
                        'input[name="hedge-mode"][value="length"]'
                    );

                if (
                    lengthRadio &&
                    lengthRadio.checked
                ) {

                    calculate();

                }

            });

        observer.observe(
            variantInput,
            {
                attributes: true,
                attributeFilter: ["value"]
            }
        );

    }


    /*
     * ==========================================
     * MENGENFELD GEÄNDERT
     * ==========================================
     */

    const quantitySelector =
        document.querySelector(
            "quantity-selector-component"
        );

    if (quantitySelector) {

        quantitySelector.addEventListener(
            "click",
            () => {

                setTimeout(
                    updatePriceFromQuantity,
                    10
                );

            }
        );

    }


    /*
     * ==========================================
     * DIREKTE MENGENEINGABE
     * ==========================================
     */

    const quantityInput =
        document.querySelector(
            'input[name="quantity"]'
        );

    if (quantityInput) {

        quantityInput.addEventListener(
            "input",
            updatePriceFromQuantity
        );

        quantityInput.addEventListener(
            "change",
            updatePriceFromQuantity
        );

    }


    /*
     * ==========================================
     * START
     * ==========================================
     */

    setInitialState();

    buildDiscountBox();

    updatePriceFromQuantity();

});